import React from "react";
import { gql, useMutation } from "@apollo/client";

import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
} from "@mui/material";

import OrderSidebar from "../index";

export default function B2B({ order }) {
  const [mutate, { loading }] = useMutation(
    React.useMemo(
      () => gql`
        mutation ($orderId: ID!, $isB2B: Boolean) {
          UpdateOrderAdmin(orderId: $orderId, isB2B: $isB2B) {
            order {
              id
              ...OrderSidebar_order
            }
          }
        }

        ${OrderSidebar.fragments.order}
      `,
      []
    )
  );

  const handleChange = React.useCallback(
    (event) =>
      mutate({
        variables: {
          orderId: order.id,
          isB2B: event.target.checked,
        },
      }),
    [mutate, order.id]
  );

  if (order.paymentId) return null;

  return (
    <FormControl>
      <FormControlLabel
        control={
          <Checkbox
            checked={!!order.isB2B}
            onChange={handleChange}
            disabled={loading}
          />
        }
        label="Commande adressée à un professionnel"
      />
      {order.isB2B && (
        <FormHelperText>
          La TVA sera ignorée si le num. de TVA est rempli dans l’adresse (sauf
          FR & GB).
        </FormHelperText>
      )}
    </FormControl>
  );
}

B2B.fragments = {
  order: gql`
    fragment OrderSidebar_Cart_B2B_order on Order {
      id
      paymentId
      isB2B
      deferredPaymentAllowed
      stripeCustomerId
      stripePaymentMethodId
    }
  `,
};
